import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class GembaWalkService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  addGembaWalk(data: any): Observable<any> {
    // return this.http.post<any>(this.baseUrl + '', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/AddGembaWalk', data
    );
  }

  updateGembaWalk(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/UpdateGembaWalk', data
    );
  }
/*
  auditCategories(data: any): Observable<any> {
    return this.http.put<any>(this.baseUrl + 'auditcategories', data);
  }
  */

  deleteGembaWalk(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/DeleteGembaWalk', data);
  }
//Not Used
  // setNewActions(data: any): Observable<any> {
  //   // return this.http.post<any>(this.baseUrl + 'gembaaction', data);
  //   return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/SetAction', data);
  // }

  getGembaWalk(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'GembaWalk/GetAllGembaWalk',
      data
    );
  }
  //Not Used
  // setCompletionDates(data: any): Observable<any> {
  //   //return this.http.post<any>(this.baseUrl + 'gembacompletiondate', data);
  //   return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/SetCompletionDate', data);
   
  // }

  setNewTargetDates(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/SetNewTargetDate', data);
  }

  setNewRemarks(data: any): Observable<any> {
    //return this.http.post<any>(this.baseUrl + 'gembaremarks', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/SetNewGembaRemarks', data);
    
  }
//Not Used
  // setNewResponsible(data: any): Observable<any> {
  //   // return this.http.post<any>(this.baseUrl + 'gembaresponsible', data);
  //   return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/SetNewResponsible', data);
    
  // }
//Not Used
  // setTargetDate(data: any): Observable<any> {
  //   // return this.http.post<any>(this.baseUrl + 'gembadate', data);
  //   return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/SetGembaTargetDate', data);
    
  // }
   //Not IN USE
  // setGembaImage(data: any): Observable<any> {
  //   return this.http.post<any>(this.baseUrl + 'gembaimage', data);
  // }
  setGembaActionImage(data: any): Observable<any> {
    
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/gembaDefectActionImage', data);
  }
   //Not IN USE
  // getGeneralCategories(data: any): Observable<any[]> {
  //   //return this.http.post<any[]>(this.baseUrl + 'getgeneralcategories', data);
  //   return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/GetGeneralCategories', data);
  // }
  addGembaActions(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/AddGembaWalkActions', data);
  }
  getgembaactions(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/GetGembaWalkActionsById', data);
  }
  deletegembaaction(data: any): Observable<any> {
    //return this.http.post<any>(this.baseUrl + 'deletegembaaction', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/DeleteGembaWalkAction', data);
    
  }
  //Not IN USE
  // gembaactioncompletiondate(data: any): Observable<any> {
  //   // return this.http.post<any>(
  //   //   this.baseUrl + 'gembaactioncompletiondate',
  //   //   data
  //   // );
  //   return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/AddActionsCompletionDate', data);
    
  // }
  getUsersActions(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/getAllUsersActions', data);
  }
  setUsersActionsCompleted(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/setUserActionsCompleted', data);
  }
  setActionRemarks(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/setGembaActionRemarks', data);
  }
  setUsersActionsRejected(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/setUserActionsRejected', data);
  }
  setUsersActionsVerified(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/setUserActionsVerified', data);
  }
  setGembaClosed(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/SetGembaClosed', data);
  }

  getGembaActions2(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/GetGembaWalkActions', data
    );
  }

  getGembafiles(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/GetGembafiles', data
    );
  }

  addGembafiles(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/AddGembafiles', data
    );
  }

  deleteDefectFiles(data: any): Observable<any>  {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/DeleteDefectFiles', data
    );
  }

  getGembaCatagories(data:any): Observable<any>
  {
    return this.http.post<any>(this.O3CoreApiUrl + 'GembaWalk/GetGembaCatagories',data);
  }
}
